import { Indent, IndentBlock, Plugin } from 'ckeditor5';

export class MaxIndent extends Plugin {
  static get requires() {
    return [Indent, IndentBlock];
  }

  private get _defaultIndent() {
    return 5;
  }

  init() {
    this._initMaxIndent();
  }

  private readonly _initMaxIndent = () => {
    const { _defaultIndent, editor } = this;
    const max = editor.config.get('maxIndent.max') ?? _defaultIndent;

    editor.model.document.on('change', () => {
      const selectedElement = editor.model.document.selection.getFirstPosition()?.parent;
      const indentListCommand = editor.commands.get('indentList');
      const id = 'max-indent';

      if (selectedElement?.name === 'listItem' && Number(selectedElement.getAttribute('listIndent')) >= max) {
        indentListCommand?.forceDisabled(id);
      } else {
        indentListCommand?.clearForceDisabled(id);
      }
    });
  };
}
